import { createStandardAction, createAsyncAction } from 'typesafe-actions'
import {
  GetCheckListReq,
  GetCheckListByIdReq,
  DeleteCheckListReq,
  CreateCheckListReq,
  UpdateCheckListReq,
  CheckListItem,
  CheckListDetail,
} from './types'
import { GetApiResponse, List } from 'features/types/common'
import { ProjectCheckListResp } from 'features/types/checklist'

export const getCheckListAction = createAsyncAction(
  'checklist/auditPlan/GET_CHECK_LIST_REQ',
  'checklist/auditPlan/GET_CHECK_LIST_RESP',
  'checklist/auditPlan/GET_CHECK_LIST_FAIL'
)<GetCheckListReq, GetApiResponse<List<CheckListItem>>, Error>()

export const getCheckListByIdAction = createAsyncAction(
  'checklist/auditPlan/GET_CHECK_ID_REQ',
  'checklist/auditPlan/GET_CHECK_ID_RESP',
  'checklist/auditPlan/GET_CHECK_ID_FAIL'
)<GetCheckListByIdReq, GetApiResponse<CheckListDetail>, any>()

export const createCheckListAction = createAsyncAction(
  'checklist/auditPlan/CREATE_CHECK_ID_REQ',
  'checklist/auditPlan/CREATE_CHECK_ID_RESP',
  'checklist/auditPlan/CREATE_CHECK_ID_FAIL'
)<CreateCheckListReq, any, any>()

export const updateCheckListAction = createAsyncAction(
  'checklist/auditPlan/UPDATE_CHECK_ID_REQ',
  'checklist/auditPlan/UPDATE_CHECK_ID_RESP',
  'checklist/auditPlan/UPDATE_CHECK_ID_FAIL'
)<UpdateCheckListReq, any, any>()

export const deleteCheckListAction = createAsyncAction(
  'checklist/auditPlan/DELETE_CHECK_ID_REQ',
  'checklist/auditPlan/DELETE_CHECK_ID_RESP',
  'checklist/auditPlan/DELETE_CHECK_ID_FAIL'
)<DeleteCheckListReq, any, any>()

export const clearCheckListDetail = createStandardAction(
  'checklist/auditPlan/CLEAR_CHECK_LIST_DETAIL'
)<void>()

export const updateCheckListDetail = createStandardAction(
  'checklist/auditPlan/UPDATE_CHECKLIST_DETAIL'
)<CheckListDetail>()

export const getProjectAction = createAsyncAction(
  'checklist/auditPlan/GET_PROJECT_REQ',
  'checklist/auditPlan/GET_PROJECT_RESP',
  'checklist/auditPlan/GET_PROJECT_FAIL'
)<any, ProjectCheckListResp, any>()
